import { Component } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-installer',
  templateUrl: './installer.component.html',
  styleUrls: ['./installer.component.scss']
})
export class InstallerComponent {
  constructor(public route: ActivatedRoute) {}

  navLinks = [
    { path: 'bids', label: 'Bids' },
    { path: 'company', label: 'Company Info' },
  ];

  get path(): string {
    return this.route.firstChild?.snapshot.url[0]?.path ?? '';
  }
}
